import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@appwin/ui/styles.css';
import './index.css';
import { App } from './App.js';

const container = document.getElementById('root');
if (!container) throw new Error('missing #root element');

createRoot(container).render(
  <StrictMode>
    <App locale={document.documentElement.lang === 'ru' ? 'ru' : 'en'} />
  </StrictMode>,
);
